<template>
<body>
    <div style="background-color:#ffffff">

        <v-container>
            <Productos :title="title" :imgproducto="imgproducto" :txt1="txt1" :contenidos="contenidos" :txt2="txt2" :txt3="txt3" :ventas="ventas" :id="id">
            </Productos >
            
       </v-container>
         

    </div>
    </body>
</template>


<script>
import Productos from "@/components/Productos.vue"

export default {
   
    components:{
       Productos
     },

    data(){
        return{
            id:"kit3",
            title:"Kit Lalabum alimentación sana",
            imgproducto:"KitBolsa3k.png",
            txt1:"El kit incluye 5 actividades coloreables como:",
            contenidos:[
             {title:"Lotería"},
             {title:"Rompecabezas"},
             {title:"Memoramas"},
             {title:"Títeres"},
             {title:"Flashcards"},
             {title:"Acceso a la app Mundo Lalabum"}
            
           ],
           txt2:"La app ofrece para tus niños más de 240 juegos, cuentos, canciones y videos que ayudan a practicar los valores de forma divertida en inglés y español.",
           txt3:"El kit Lalabum “Alimentación sana” está diseñado para reforzar las buenas conductas y actitudes hacia una alimentación sana. Es ideal para niños entre 5 y 7 años.",
           ventas:[
             {comercio:"Mercado Libre",url:"https://cutt.ly/egYSDR8"},
             {comercio:"Paypal",url:"https://www.paypal.com/cgi-bin/webscr?cmd=_s-xclick&hosted_button_id=U9ZCAF7GF77DE"},
             /*{comercio:"Gonvil",url:"https://cutt.ly/4gYJovD"},
             {comercio:"Delti",url:"https://cutt.ly/4gYJovD"}*/
           ]
        }
    }
}
</script>

<style scoped>
.description.kit2,.producto.kit2{
    color:#50b05e;
}
</style>


